import Icon from '../components/Icon.vue'

Icon.register({
  lock: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 224c26.5 0 48 21.5 48 48v192c0 26.5-21.5 48-48 48h-352c-26.5 0-48-21.5-48-48v-192c0-26.5 21.5-48 48-48h24v-72c0-83.8 68.2-152 152-152s152 68.2 152 152v72h24zM296 224v-72c0-39.7-32.3-72-72-72s-72 32.3-72 72v72h144z'
      }
    ]
  }
})
